export default __webpack_public_path__ + "static/media/art-pro-red-3.242c66e7.png";